import { Alert, SxProps, useTheme } from '@mui/material'
import React from 'react'
import { InfoIcon } from '../icons'

export const WarningBanner: React.FC<{ children: React.ReactNode; alertSx?: SxProps }> = ({ children, alertSx = { marginBlock: 2 } }) => {
  const theme = useTheme()
  return (
    <Alert
      sx={{
        color: theme.palette.grey.grey00,
        backgroundColor: theme.palette.grey.grey07,
        alignItems: 'center',
        ...alertSx,
      }}
      icon={<InfoIcon sx={{ color: theme.palette.grey.grey00 }} />}
    >
      {children}
    </Alert>
  )
}
